import { createActions, createReducer } from 'reduxsauce'
import DespesasMensaisService from '../../servicos/DespesasMensaisService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasMensaisInicio: [],
    buscaDespesasMensaisSucesso: ['despesasMensais'],
    buscaDespesasMensaisErro: ['erro'],
    setSelecionadoDespesasMensaisSucesso: ['selecionado'],
    setDespesasMensaisEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasMensais = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDespesasMensaisInicio())
        let serv = new DespesasMensaisService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDespesasMensaisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasMensaisErro(error)))
    }
}

const buscaDespesasMensaisInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasMensaisErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDespesasMensaisSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasMensais.resultado, dataSincronizacaoDados: action.despesasMensais.dataSincronizacaoDados, carregando: false }
}

const setSelecionadoDespesasMensaisSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setDespesasMensaisEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_MENSAIS_INICIO]: buscaDespesasMensaisInicio,
    [Types.BUSCA_DESPESAS_MENSAIS_ERRO]: buscaDespesasMensaisErro,
    [Types.BUSCA_DESPESAS_MENSAIS_SUCESSO]: buscaDespesasMensaisSucesso,
    [Types.SET_SELECIONADO_DESPESAS_MENSAIS_SUCESSO]: setSelecionadoDespesasMensaisSucesso,
    [Types.SET_DESPESAS_MENSAIS_ESTADO_DT]: setDespesasMensaisEstadoDT,
})
